import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  conversations: null,
  error: "",
};

const conversationsSlice = createSlice({
  name: "conversationsSlice",
  initialState: initialState,
  reducers: {
    setState(state, action) {
      state.loading = action.payload.loading;
      state.error = action.payload.error;
      state.conversations = action.payload.conversations;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setConversaions(state, action) {
      state.conversations = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const conversationsActions = conversationsSlice.actions;

export default conversationsSlice.reducer;
